/**
 * i18next configuration for the SmartSafe Portal SPA.
 *
 * Fixed locale: pt-BR.
 * The portal content is in Brazilian Portuguese. Multi-locale support
 * (en-US, es-419) is kept in the resource bundle for future use but
 * the UI language is not user-configurable at this stage.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ptBR from './locales/pt-BR.json';
import enUS from './locales/en-US.json';
import es419 from './locales/es-419.json';

export const SUPPORTED_LOCALES = ['pt-BR', 'en-US', 'es-419'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_LABELS: Record<SupportedLocale, string> = {
  'pt-BR': 'Português (BR)',
  'en-US': 'English',
  'es-419': 'Español (LATAM)',
};

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': { translation: ptBR },
      'en-US': { translation: enUS },
      'es-419': { translation: es419 },
    },
    lng: 'pt-BR',
    fallbackLng: 'pt-BR',
    supportedLngs: [...SUPPORTED_LOCALES],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
